import Axios from "../../src/helpers/axios";

export const getAllProductSubCategories = () => {
  return Axios.get(`/api/ecommerce/v1/productsubcategories`);
};
